var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRewardsHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#60B0F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0457 11.7656L15.4247 11.1774L13.8405 7.76601C13.8061 7.68674 13.7504 7.61947 13.6802 7.57229C13.6099 7.5251 13.5281 7.5 13.4444 7.5C13.3608 7.5 13.2789 7.5251 13.2087 7.57229C13.1384 7.61947 13.0828 7.68674 13.0484 7.76601L11.4642 11.1774L7.8432 11.7656C7.75489 11.771 7.67158 11.81 7.60902 11.875C7.54647 11.94 7.50901 12.0267 7.50373 12.1185C7.48697 12.2843 7.52704 12.4509 7.61688 12.589L10.2195 15.177L9.65369 18.9412C9.64205 19.0342 9.65736 19.1286 9.69769 19.2125C9.73801 19.2963 9.80149 19.3657 9.88 19.4118C9.94231 19.4686 10.0224 19.5 10.1053 19.5C10.1882 19.5 10.2683 19.4686 10.3306 19.4118L13.499 17.6473L16.6674 19.4118H16.8957C17.0068 19.4118 17.122 19.4118 17.122 19.2941C17.191 19.2382 17.2472 19.1669 17.2863 19.0855C17.3255 19.0041 17.3467 18.9146 17.3483 18.8236L16.7825 15.0593L19.3851 12.4714C19.4736 12.3327 19.5129 12.1663 19.4963 12.0008C19.3726 11.8765 19.2154 11.7945 19.0457 11.7656Z",
    fill: "#8DC8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRewardsHistory);
export default __webpack_public_path__ + "static/media/starRewardsHistory.1fa023a9ee277037499ebc10a462b75b.svg";
export { ForwardRef as ReactComponent };